const entityMap = {
    '&': '%26',
    ',': '%2C',
    '<': '%3C',
    '>': '%3E'
};
export function escapeHtml(str: string): string {
    return str.replace("&", "%26").replace(",", "%2C");
}

export function composePathPoi(adr1:string, adr2:string, poiname:string, travel:string, poiid:string, code:string):string {
    const path = "/" + encodeURIComponent(adr1) +
        "/" + encodeURIComponent(adr2) +
        "/" + encodeURIComponent(poiname) +
        "/" + encodeURIComponent(travel) +
        "/" + encodeURIComponent(poiid);

    if (code) {
        return path + "?code=" + encodeURIComponent(code)
    }
    else {
        return path;
    }
}

export function composePathRoot(adr1: string, adr2: string, poiname: string, travel: string, code: string): string {
    const path = "/" + encodeURIComponent(adr1) +
        "/" + encodeURIComponent(adr2) +
        "/" + encodeURIComponent(poiname) +
        "/" + encodeURIComponent(travel);

    if (code) {
        return path + "?code=" + encodeURIComponent(code)
    }
    else {
        return path;
    }
}